import React, { useState, useEffect, Component } from 'react'
import { API_URL } from '../../constants';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom';
import { Modal, Button, Form } from "react-bootstrap";
import { FaSpinner } from 'react-icons/fa';
const ThankYou = () => {
    return <>
       <div style={{
    backgroundColor: '#f8f9fa',
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    padding: '20px 0'
}}>
    <div style={{
        width: '100%',
        maxWidth: '800px',
        margin: '0 auto',
        padding: '30px'
    }}>
        <div style={{
            backgroundColor: 'white',
            borderRadius: '10px',
            padding: '30px',
            boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
            textAlign: 'center',
            borderLeft: '5px solid #27568B',
            position: 'relative',
            overflow: 'hidden'
        }}>
            <div style={{
                position: 'absolute',
                top: '0',
                left: '0',
                width: '100%',
                height: '5px',
                background: ' #27568B',
            }}></div>
            
            <h3 style={{
                color: '#27568B',
                marginBottom: '20px',
                fontWeight: '600'
            }}>Offer Accepted Successfully!</h3>
            
            <p style={{
                fontSize: '1.1rem',
                lineHeight: '1.6',
                color: '#555',
                marginBottom: '25px'
            }}>
                Thank you for accepting the offer letter. Kindly check your inbox 
                for the accepted copy of offer letter. We are looking forward 
                to having you in the Nice family!
            </p>
            
            <div style={{
                backgroundColor: '#f1f8e9',
                padding: '15px',
                borderRadius: '8px',
                margin: '20px 0',
                borderLeft: '3px solid #27568B'
            }}>
                <p style={{
                    margin: '0',
                    color: '#33691E',
                    fontWeight: '500'
                }}>
                    In case of any query, please connect with HR personnel of
                    Nice Software Solutions
                </p>
            </div>
        </div>
    </div>
</div>
    </>
}
export default ThankYou;